document.addEventListener("turbolinks:load", function () {
    // Set up access modal using functionality from vb_modal.js
    if (document.querySelector(".access-modal__button")){
        setUpModal(".access-modal__button", ".access-modal");
    }
})